import { DefaultValue } from "recoil";

const localStorageEffect = (key, share=false) => ({setSelf, onSet}) => {
  const savedValue = localStorage.getItem(key)
  if (savedValue != null) {
    try {
      setSelf(JSON.parse(savedValue));
    } catch {
      setSelf(savedValue);
    }
  } else {
    setSelf(new DefaultValue());
  }

  onSet(newValue => {
    localStorage.setItem(key, JSON.stringify(newValue));
  });

  if (share) {
    window.addEventListener('storage', (e) => {
      if (key === e.key) {
        try {
          setSelf(JSON.parse(e.newValue));
        } catch {
          setSelf(e.newValue);
        }
      }
    });
  }
};

export default localStorageEffect;